import { render, staticRenderFns } from "./TotalLeverageCard.vue?vue&type=template&id=35e4519a&scoped=true"
import script from "./TotalLeverageCard.vue?vue&type=script&lang=js"
export * from "./TotalLeverageCard.vue?vue&type=script&lang=js"
import style0 from "./TotalLeverageCard.vue?vue&type=style&index=0&id=35e4519a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e4519a",
  null
  
)

export default component.exports